import { render } from "./PopupModal.vue?vue&type=template&id=5162e7bb&scoped=true"
import script from "./PopupModal.vue?vue&type=script&lang=js"
export * from "./PopupModal.vue?vue&type=script&lang=js"

import "./PopupModal.vue?vue&type=style&index=0&id=5162e7bb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5162e7bb"]])

export default __exports__